import React from "react";
import * as MUI from "@material-ui/core";
import cn from "classnames";
import { NavLink } from "../NavLink";
import { NavigationProps } from "./types";
import { useNavigationStyles } from "./styles";

export default Navigation;

export function Navigation(props: NavigationProps) {
  const { links, children } = props;
  const classes = useNavigationStyles(props);
  const navLinks = links && links.map((link) => <NavLink {...link} />);
  const classNameRoot = cn(classes.root, props.className);
  return <MUI.Box className={classNameRoot}>{children || navLinks}</MUI.Box>;
}

export * from "./types";
